"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const common_utils_1 = require("@zapier/common-utils");
const MAX_OPTIONS_RENDERED_INCREMENT = 10;
function ChunkingItemRenderer(_a) {
    var { children, items, renderItem } = _a, props = __rest(_a, ["children", "items", "renderItem"]);
    const [maxScrolledTop, setMaxScrolledTop] = react_1.useState(0);
    const [maxItemsToRender, setMaxItemsToRender] = react_1.useState(MAX_OPTIONS_RENDERED_INCREMENT);
    const onScroll = (e) => {
        const { offsetHeight, scrollHeight, scrollTop } = e.target;
        if (scrollTop + offsetHeight > scrollHeight - offsetHeight &&
            scrollTop > maxScrolledTop) {
            setMaxScrolledTop(scrollTop);
            setMaxItemsToRender(prev => prev + MAX_OPTIONS_RENDERED_INCREMENT);
        }
    };
    const itemsToRender = items.slice(0, maxItemsToRender);
    return (common_utils_1.isolateComponent(react_1.Fragment, null,
        common_utils_1.isolateComponent("div", Object.assign({}, props, { onScroll: onScroll }),
            itemsToRender.map(renderItem),
            children)));
}
exports.default = ChunkingItemRenderer;
